import { useQuery } from "@apollo/client";
import { Box } from "@chakra-ui/react";
import { capitalize, get, startCase } from "lodash";
import React from "react";
import ReactSelect from "react-select";
import { GET_USERS_PUBLIC } from "../../pages/public/queries";

type SelectEstablishmentProps = {
  onChange?: any;
};

const SelectEstablishment = (props: SelectEstablishmentProps) => {
  const { onChange } = props;
  const { data, loading } = useQuery(GET_USERS_PUBLIC, {
    variables: {
      args: {
        pagination: {
          page: 1,
          size: 100,
        },
      },
    },
    fetchPolicy: "network-only",
  });

  const users = get(data, "publicUsers.items", []);

  const options = users.map((user: any) => {
    return {
      label: startCase(capitalize(user.name)),
      value: user.id,
    };
  });

  return (
    <Box mr="2">
      <ReactSelect
        isLoading={loading}
        isClearable
        closeMenuOnSelect={false}
        options={options}
        isMulti
        onChange={(val: any) => {
          const values = val.map((v: any) => v.value);
          onChange && onChange(values);
        }}
      />
    </Box>
  );
};

export default SelectEstablishment;
